import { templateBlanks } from "@clevis/shared-types";
import { Input } from "@clevis/shared-ui";

// One box per blank in a template, each shown in the sentence it belongs to
// ("The plan is ___ per month…"), so nobody has to find brackets in the text.

export function BlankFiller({ body, values, onChange }: { body: string; values: Record<string, string>; onChange: (values: Record<string, string>) => void }) {
  const blanks = templateBlanks(body);
  if (!blanks.length) return null;
  return (
    <div className="space-y-2">
      {blanks.map((b) => {
        const [before, after] = b.context.split("___");
        return (
          <div key={b.blank}>
            <p className="text-xs text-steel">
              {before}
              <span className="rounded bg-brandorange/15 px-1 font-semibold text-brandorange-dark">{values[b.blank]?.trim() || "___"}</span>
              {after}
            </p>
            <Input
              className="mt-0.5 py-1 text-sm"
              value={values[b.blank] ?? ""}
              placeholder={b.label}
              maxLength={500}
              onChange={(e) => onChange({ ...values, [b.blank]: e.target.value })}
            />
          </div>
        );
      })}
    </div>
  );
}

/** Blanks still empty. */
export const unfilled = (body: string, values: Record<string, string>) => templateBlanks(body).filter((b) => !values[b.blank]?.trim());

/** Starting values: the template's own suggestions ("[30]" → "30"). */
export const startingValues = (body: string): Record<string, string> =>
  Object.fromEntries(templateBlanks(body).filter((b) => b.suggestion).map((b) => [b.blank, b.suggestion]));
